import React from 'react'

import About from '../pages/About'
import Contact from '../pages/Contact'
import Home from '../pages/Home'
import Projects from '../pages/Projects'

import { Route, Routes,useLocation } from 'react-router-dom'

import{ AnimatePresence,} from 'framer-motion'



const AnimRoute = () => {

  const location = useLocation()
  return (
    <AnimatePresence initial={true} mode='wait'>
       
        <Routes key={location.pathname} location={location}>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/contact' element={<Contact />} />
        </Routes>
       
      
    </AnimatePresence>
   
  )
}

export default AnimRoute

